//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { InfoIcon } from 'vue-feather-icons';
export default {
	name: 'Checkbox',
	components: {
		InfoIcon,
	},
	props: {
		model: [Number, String, Boolean],
		label: String,
		id: String,
		disabled: Boolean,
		tooltip: String,
		errors: {
			type: Array,
			default() {
				return [];
			},
		},
		values: {
			type: Object,
			default() {
				return { checked: 1, unchecked: 0 };
			},
		},
	},
	data() {
		return {
			value: 0,
		}
	},
	watch: {
		model: function (newValue) {
			this.value = newValue;
		}
	},
	computed: {
		state() {
			return this.errors == null || this.errors.length == 0 ? null : this.errors.length == 0;
		},
		invalidFeedback() {
			if (this.errors.length) {
				return this.errors[0];
			}
			return null;
		},
	},
	mounted() {
		if (this.model !== undefined) {
			this.value = this.model
		}
	},
}
